import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';
import { ConfiguredPartner } from '@savgroup-front-common/types/Onboarding/ConnectedPartner';

const ENDPOINT = `${APIConfiguration.seller}ConfiguredPartner`;

interface UpsertConfiguredPartnerCommandPayload {
  configuredPartner: ConfiguredPartner;
}

const upsertConfiguredPartnerCommand = async ({
  configuredPartner,
}: UpsertConfiguredPartnerCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> => {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        ...configuredPartner,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default upsertConfiguredPartnerCommand;
